import { render, staticRenderFns } from "./HotelBook.vue?vue&type=template&id=1af0a2d7&scoped=true"
import script from "./HotelBook.vue?vue&type=script&lang=js"
export * from "./HotelBook.vue?vue&type=script&lang=js"
import style0 from "./HotelBook.vue?vue&type=style&index=0&id=1af0a2d7&prod&lang=css"
import style1 from "./HotelBook.vue?vue&type=style&index=1&id=1af0a2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af0a2d7",
  null
  
)

export default component.exports